module.exports = __webpack_public_path__ + "img/3f_r_cavallo.b0ca6319.png";